const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://taxilosprimos.dvgeo.app' : 'http://192.168.100.106:3023',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://taxilosprimos.dvgeo.app' : 'http://192.168.100.106:3023',
    api: 'api/',
    apiSocket: 'taxilosprimos::1.2',
    nameDir: 'taxilosprimos',
    package: 'app.dvgeo.taxilosprimos.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyBWy2PNOZzYahaJ161-WZc3IyTak_dwvWs',
    appName: 'Taxi Los Primos',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#1F3F6B',
    colorDark: '#0B2035',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.taxilosprimos.passenger',
    playStoreDriverId: 'app.dvgeo.taxilosprimos.driver',
    appStorePassengerId: '6819400100',
    appStoreDriverId: '6819400001',
};
export default config;
